import { gql } from '@apollo/client';

export const SAVED_ARTICLES_QUERY = gql`
    query getSavedArticles {
        articles {
            recordId
            url
            publishedAt
            title
            types
        }
    }
`;

export const SAVE_ARTICLE = gql`
    mutation SaveArticle($recordId: Int!) {
        saveArticle(recordId: $recordId) {
            article {
                recordId
            }
        }
    }
`;

export const REMOVE_ARTICLE = gql`
    mutation RemoveArticle($recordId: Int!) {
        removeArticle(recordId: $recordId) {
            article {
                recordId
            }
        }
    }
`;
